module.exports = __webpack_public_path__ + "img/ca.af259017.svg";